import { render, staticRenderFns } from "./UserAssetEmails.vue?vue&type=template&id=a3c243c0"
import script from "./UserAssetEmails.vue?vue&type=script&lang=js"
export * from "./UserAssetEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports